import React from "react";

import { Box, Flex, Grid, GridItem } from "@chakra-ui/react";

import { defaultValues } from "../../../defaultValues";
import { FilterDropDown } from "../../components/FilterDropDown";

export const TipologiaHeader: React.FC = () => {
	return (
		<Box h=".5rem" background="transparent" p="0 1rem" mb=".5rem">
			<Flex width="100%" height="100%" alignItems="center">
				<Grid templateColumns="repeat(16, 1fr)" w="100%" pr="1.5rem" pl=".3rem">
					<GridItem colSpan={1}>
						<FilterDropDown column="por_validar" values={defaultValues.por_validar} />
					</GridItem>
					<GridItem colSpan={4}>
						<FilterDropDown column="nombre" />
					</GridItem>
					<GridItem colSpan={2}>
						<FilterDropDown column="ambito" values={defaultValues.ambito} />
					</GridItem>
					<GridItem colSpan={2}>
						<FilterDropDown column="tipologia" values={defaultValues.tipologia} />
					</GridItem>
					<GridItem colSpan={2}>
						<FilterDropDown column="agrupacion" />
					</GridItem>
					<GridItem colSpan={2}>
						<FilterDropDown column="usos" values={defaultValues.usos} />
					</GridItem>
					<GridItem colSpan={2}>
						<FilterDropDown column="especialidades" values={defaultValues.especialidades} />
					</GridItem>
					<GridItem colSpan={1}>
						<FilterDropDown column="relevancia" values={defaultValues.relevancia} />
					</GridItem>
				</Grid>
			</Flex>
		</Box>
	);
};
